module.exports = __webpack_public_path__ + "static/my-safety-logo-fd6864486ed62ccfe82444d556880723.png";